export var intersectAny = function (arr1, arr2) {
    var notFoundIndex = -1;
    return arr1.some(function (r) { return arr2.indexOf(r) !== notFoundIndex; });
};
